var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSGyro({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "2030.391 6170.607 60.977 60.977",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 6.403,
    x2: 6.403,
    y1: 0,
    y2: 12.807,
    gradientTransform: "scale(2.5583 .39088)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#404040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "f",
    x1: -0.545,
    x2: -0.545,
    y1: 0.399,
    y2: 6.859,
    gradientTransform: "scale(3.18974 .3135)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "e",
    x1: -0.573,
    x2: -0.573,
    y1: 0,
    y2: 6.901,
    gradientTransform: "scale(3.03305 .3297)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a8a9a8",
    d: "M9.708 60.977a9.336 9.336 0 0 1-1.983-.455H3.489a1.972 1.972 0 0 1-1.972-1.972V54H.758A.758.758 0 0 1 0 53.241V6.978a.758.758 0 0 1 .758-.759h.759V1.972A1.972 1.972 0 0 1 3.489 0h12.654v.607h3.42V0h12.746a1.972 1.972 0 0 1 1.972 1.972v4.247h.91a.759.759 0 0 1 .759.759v46.263a.758.758 0 0 1-.759.758h-.91v4.551a1.972 1.972 0 0 1-1.972 1.972h-4.141c-.17.3-1.911.455-2.229.455z",
    className: "cls-1",
    "data-name": "Union 7"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    width: 35.764,
    height: 50.78,
    x: 2030.408,
    y: 6169.107,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in",
    result: "result1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "result1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 16"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)",
    "data-name": "Mask Group 7",
    transform: "translate(2042.905 6170.607)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a8a9a8",
    d: "M.758 6.219h34.433a.758.758 0 0 1 .758.758v46.264a.758.758 0 0 1-.758.758H.758A.758.758 0 0 1 0 53.241V6.977a.758.758 0 0 1 .758-.758Z",
    className: "cls-1",
    "data-name": "Path 29"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9a9a9a",
    d: "M15.017.607h5.764v15.775h-5.764z",
    "data-name": "Rectangle 11"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)",
    transform: "translate(-2030.39 -6170.61)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a8a9a8",
    d: "M2033.882 6170.61h12.655v16.015l3.42-.251v-15.764h12.745a1.972 1.972 0 0 1 1.972 1.972v43.837a1.972 1.972 0 0 1-1.972 1.972h-28.82a1.972 1.972 0 0 1-1.972-1.972v-43.837a1.972 1.972 0 0 1 1.972-1.972Z",
    className: "cls-1",
    "data-name": "Path 12"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "hvid"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M2.73 29.578h30.337a1.213 1.213 0 0 1 1.213 1.213V58.55a1.972 1.972 0 0 1-1.972 1.972H3.489a1.972 1.972 0 0 1-1.972-1.972V30.791a1.213 1.213 0 0 1 1.213-1.213Z",
    "data-name": "Path 57"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M0 0h32.764v3.034a1.972 1.972 0 0 1-1.972 1.972H1.972A1.972 1.972 0 0 1 0 3.034Z",
    "data-name": "Path 59",
    opacity: 0.6,
    transform: "translate(1.517 55.516)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "url(#e)",
    "data-name": "Path 1",
    transform: "translate(19.453 58.701)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M6.485 2.15h-16.23c-.136 0-.679-.09-1.254-.238-.65-.167-.942-.306-1.042-.382l1.25-1.037c.303-.253.754-.368 1.046-.368h16.23c.22 0 .395.157.599.338.052.047.106.095.163.141l1.318 1.19c-.078.05-.302.148-.928.244-.49.075-1.003.112-1.152.112Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9a9a9a",
    d: "M6.485 2.025c.369 0 1.422-.122 1.856-.265L7.165.699C7.108.652 7.053.603 7 .556 6.816.392 6.657.25 6.485.25h-16.23c-.27 0-.687.106-.967.34l-1.113.924c.473.22 1.776.511 2.08.511h16.23m0 .25h-16.23c-.335 0-2.458-.437-2.458-.772l1.332-1.106C-10.553.13-10.081 0-9.745 0h16.23c.335 0 .57.285.843.51l1.4 1.262c0 .335-1.908.503-2.243.503z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "red things",
    transform: "translate(4.551 8.494)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.034,
    cy: 3.034,
    r: 3.034,
    fill: "#b72b1c",
    className: "cls-7",
    "data-name": "red dot",
    transform: "translate(10.315 5.916)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b72b1c",
    d: "M5.371 14.865s-3.9-5.13-.759-10.77c.232.143.682.347.91.455.645.367.74-.309.607-.758C5.829 2.844 4.915 0 4.915 0L1.123 1.062a1.446 1.446 0 0 0-.455.152c-.2.125-.369.4 0 .607l1.062.607S-2.796 9.08 2.792 16.686c1.598-1.14 2.579-1.821 2.579-1.821z",
    className: "cls-7",
    "data-name": "red arrow 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b72b1c",
    d: "M21.293 14.865s3.9-5.13.758-10.77c-.231.143-.681.347-.91.455-.645.367-.741-.309-.607-.758.3-.948 1.213-3.792 1.213-3.792l3.792 1.062a1.446 1.446 0 0 1 .455.152c.2.125.368.4 0 .607l-1.062.607s4.526 6.652-1.062 14.258a233.606 233.606 0 0 0-2.577-1.821z",
    className: "cls-7",
    "data-name": "red arrow 2"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSGyro);
export default __webpack_public_path__ + "static/media/sGyro.e8909007059c30b5cb5420a6a9961780.svg";
export { ForwardRef as ReactComponent };